import { useFormikContext } from 'formik'
import { VField } from '../../components/Fields'
import { Bilancia, Intervento } from '../../types'
import { getLabelTipoBilancia } from '../../utils/utils'

export default function FormInterventoVeloce({
  bilancia,
}: {
  bilancia: Bilancia | undefined
}) {
  const { values } = useFormikContext<Intervento>()

  return (
    <div className="row">
      <div className="col-12 mb-4">
        <div className="heading-h3">
          {bilancia?.matricola} {bilancia?.sigla ? `(${bilancia.sigla})` : ''} -{' '}
          {getLabelTipoBilancia(bilancia?.tipo_bilancia)}
        </div>
        <div className="p-md text-body-secondary mt-2">
          {bilancia?.cliente_ragione_sociale} -{' '}
          {bilancia?.sede_data?.numero_rea} {bilancia?.reparto}
        </div>
      </div>
      {values.tipo_intervento === 'verifica_periodica' && (
        <div className="col-md-6">
          <VField
            name="data_richiesta"
            label="Data richiesta"
            required
            type="date"
          />
        </div>
      )}
      <div className="col-md-6">
        <VField
          name="data_intervento"
          label="Data intervento"
          required
          type="date"
        />
      </div>
      <div className="col-md-6">
        <VField name="durata_stimata" label="Durata stimata" type="time" />
      </div>
      <div className="col-md-12 mt-2">
        <VField name="note" label="Note" as="textarea" />
      </div>
    </div>
  )
}
